import React from 'react';

import { Button } from '@xarvio/button';
import styles from './EmailVerifiedPage.module.scss';
import { TranslateMessage } from '@xarvio/utils';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import {
  countrySelector,
  localeSelector,
} from '@xarvio/frontend-core-state/lib/intl/selectors';
import { getPagesUrl } from '@xarvio/frontend-core-platform/lib/routerUrls';

export const EmailVerifiedPage: React.FC<
  React.PropsWithChildren<unknown>
> = () => {
  const history = useNavigate();
  const country = useSelector(countrySelector);
  const locale = useSelector(localeSelector);
  const { landingPageUrl } = getPagesUrl({ country, locale });

  return (
    <div className={styles.emailVerifiedLayout}>
      <div className={styles.topLogo} />

      <div className={styles.container}>
        <TranslateMessage
          tag="h2"
          id="component.EmailVerified.title"
          className="mb-l"
        />
        <Button
          label={<TranslateMessage id="component.EmailVerified.button" />}
          type="primary"
          size="medium"
          onClick={() => history(landingPageUrl)}
        />
      </div>
    </div>
  );
};

export default EmailVerifiedPage;
